import { MapLeafletService } from '@/services';

export default () => {
  function initMap({
    containerId = 'thematicCardMap',
    mapOptions = {},
  }) {
    const mapConfig = MapLeafletService.getMapConfig();
    const settings = {
      // TO change in next ticket
      latitude: 48.833,
      longitude: 2.333,
      zoom: mapConfig.default_zoom || 10,
      mapTilerEnabled: mapConfig.maptilerEnabled === 1,
      mapUrl: mapConfig.maptilerEnabled
        ? `${mapConfig.maptiler.tileUrl}?key=${
          mapConfig.maptiler.apiKey}`
        : `https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=${
          mapConfig.mapbox.accessToken}`,
      attribution: '',
      map: null,
      blueIcon: null,
      markers: null,
    };
    if (mapConfig && ((mapConfig.maptilerEnabled && mapConfig.maptiler.apiKey)
              || mapConfig.mapbox.accessToken)) {
      if (settings.mapTilerEnabled) {
        settings.attribution = '\u003ca href="https://www.maptiler.com/copyright/" target="_blank"\u003e\u0026copy; MapTiler\u003c/a\u003e \u003ca href="https://www.openstreetmap.org/copyright" target="_blank"\u003e\u0026copy; OpenStreetMap contributors\u003c/a\u003e';
      } else {
        settings.attribution = '\u003ca href="https://www.mapbox.com/legal/tos" target="_blank"\u003e\u0026copy; Mapbox\u003c/a\u003e \u003ca href="https://www.openstreetmap.org/copyright" target="_blank"\u003e\u0026copy; OpenStreetMap contributors\u003c/a\u003e';
      }
      settings.map = window.L.map(containerId, mapOptions);
      new window.L.Control.Zoom({ position: 'topright' }).addTo(settings.map);
      const { map } = settings;

      map.setView([settings.latitude, settings.longitude], settings.zoom);

      window.L.tileLayer(settings.mapUrl, {
        tileSize: 512,
        zoomOffset: -1,
        minZoom: 2,
        maxNativeZoom: 21,
        maxZoom: 21,
        attribution: settings.attribution,
        crossOrigin: true,
      }).addTo(map);
    }

    return settings;
  }

  return {
    initMap,
  };
};
